import InputGroup from 'components/Form/InputGroup/formWrapper';
import React from 'react';
import 'twin.macro';
import { Field } from 'react-final-form';
import Select from '@teetsh/app/src/components/Form/Select2/formWrapper';
import { useTranslation } from 'react-i18next';
import { useTranslatedValidation } from 'utils/useTranslatedValidation';
import { NiveauValue } from 'containers/scholarSystem';

export default function Body({ niveaux }: { niveaux: NiveauValue[] }) {
  const { t } = useTranslation(['programmation']);
  const { required } = useTranslatedValidation();

  return (
    <div>
      <Field
        options={niveaux.map(v => ({ value: v, label: v }))}
        label={t('programmation:grade')}
        name="niveau"
        validate={required}
        component={Select}
      />
      <div tw="mt-8">
        <Field
          name="destProgId"
          label={t('programmation:sendToCMSProgIdLabel')}
          helperText={t('programmation:sendToCMSProgIdHelperText')}
          component={InputGroup}
          large
        />
      </div>
    </div>
  );
}
